import normalizeComposerAttachmentEntry from './normalizeComposerAttachmentEntry.js';

const normalizeComposerAttachmentEntries = (items = []) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .map((item) => {
      return normalizeComposerAttachmentEntry(item);
    })
    .filter(Boolean);
};

export default normalizeComposerAttachmentEntries;
